import { useTableActionContext } from '@aibees/elephant/context/table-action/context';
import { SearchType } from '@aibees/elephant/types';
import { IconName } from '@aibees/shared/components';
import { useMemo } from 'react';

interface UseLabelDialogConfigParams {
  isLabel: boolean;
  isEdit?: boolean;
  searchTypeOverride?: SearchType;
}

export function useLabelDialogConfig({
  isLabel,
  isEdit,
  searchTypeOverride,
}: UseLabelDialogConfigParams) {
  // Fall back to the flow's effective search type (folds in the ActionButton
  // override) so the dialog header follows the record, not just the page route —
  // e.g. a person opened from the employees sidebar on a company search page.
  const { effectiveSearchType } = useTableActionContext();
  const searchType = searchTypeOverride ?? effectiveSearchType;

  const entityTypeName = useMemo(
    () => (searchType === SearchType.People ? 'Contact' : 'Account'),
    [searchType]
  );

  const titleDialog = useMemo(
    () =>
      isLabel
        ? isEdit
          ? `Edit ${entityTypeName} Label`
          : `Create ${entityTypeName} Label`
        : isEdit
        ? `Edit ${entityTypeName} List`
        : `Create ${entityTypeName} List`,
    [isLabel, isEdit, entityTypeName]
  );
  const inputTitle = useMemo(
    () => (isLabel ? 'Label Name:' : 'List Name:'),
    [isLabel]
  );
  const dialogIcon: IconName = useMemo(
    () => (isEdit ? 'edit-outline' : isLabel ? 'label-outline' : 'list'),
    [isLabel, isEdit]
  );

  const placeholder = useMemo(
    () =>
      isLabel ? 'Enter a name for your label…' : 'Enter a name for your list…',
    [isLabel]
  );

  return {
    titleDialog,
    inputTitle,
    dialogIcon,
    placeholder,
  };
}
